/**
 * Meta Analytics Configuration
 *
 * Single source of truth for all Meta Pixel / CAPI settings.
 * Every other module in src/lib/analytics/ reads from here.
 */

export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID as string | undefined;

const PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID as string | undefined;

/** Full URL of the CAPI edge function */
export const CAPI_ENDPOINT = PROJECT_ID
  ? `https://${PROJECT_ID}.supabase.co/functions/v1/meta-capi`
  : undefined;

/** Generate a unique event ID for browser ↔ server deduplication */
export function generateEventId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export const PINTEREST_AD_ACCOUNT_ID = import.meta.env.VITE_PINTEREST_AD_ACCOUNT_ID as string | undefined;

export const PINTEREST_CAPI_ENDPOINT = PROJECT_ID
  ? `https://${PROJECT_ID}.supabase.co/functions/v1/pinterest-capi`
  : undefined;
